import { ActiveExperimentName } from './types';

// NOTE: adding or removing from this tuple requires changes to ActiveExperimentName
export const EXPERIMENTS: ActiveExperimentName[] = ['Experiment0041'];
